import {
  VERIFY_TOKEN_STARTED, VERIFY_USER_SUCCESS, VERIFY_TOKEN_END,
  USER_LOGIN_STARTED, USER_LOGIN_FAILURE, USER_LOGOUT, UPDATE_USER, UPDATE_LAST_VISITED_ROUTE, UPDATE_CHILD_USER, REMOVE_CHILD, UPDATE_SCHOOL, CHANGE_SUPERADMIN_VIEW, UPDATE_STUDENT_USER
} from "./actionTypes";

// verify token - start
export const verifyTokenStarted = (silentAuth = false) => {
  return {
    type: VERIFY_TOKEN_STARTED,
    payload: {
      silentAuth
    }
  };
};

// verify token - end/failure
export const verifyTokenEnd = () => {
  return {
    type: VERIFY_TOKEN_END
  };
};

// user login - start
export const userLoginStarted = () => {
  return {
    type: USER_LOGIN_STARTED
  };
};

// user login - failure
export const userLoginFailure = (error = 'Something went wrong. Please try again later.') => {
  return {
    type: USER_LOGIN_FAILURE,
    payload: {
      error
    }
  };
};

// verify token - success
export const verifyUserSuccess = ({ token = '', expiredAt = '', user = '' }) => {
  return {
    type: VERIFY_USER_SUCCESS,
    payload: {
      token,
      expiredAt,
      user
    }
  };
};

//update user profile
export const updateUser = ({ user }) => {
  return {
    type: UPDATE_USER,
    payload: {
      user
    }
  };
};

export const updateChildrenUser = ({ parentStudent }) => {
  return {
    type: UPDATE_CHILD_USER,
    payload: {
      parentStudent
    }
  };
};

// handle user logout
export const userLogout = () => {
  return {
    type: USER_LOGOUT
  };
};

export const updateLastRoute = (url) => {
  return {
    type: UPDATE_LAST_VISITED_ROUTE,
    payload: {
      url
    }
  };
};

export const removeChild = (data) => {
  return {
    type: REMOVE_CHILD,
    payload: {
      ...data
    }
  };
};

export const updateSchool = (data) => {
  return {
    type: UPDATE_SCHOOL,
    payload: {
      ...data
    }
  };
};

//change superadmin
export const changeSuperAdminView = data => {
  return {
    type: CHANGE_SUPERADMIN_VIEW,
    payload: {
      ...data
    }
  };
};

export const updateStudentUser = data => {
  return {
    type: UPDATE_STUDENT_USER,
    payload: {
      ...data
    }
  };
};